































import { Component, Vue } from 'vue-property-decorator'
import {
  get1stAndToday,
  past7Day,
  past30Day,
  pastWeek,
  pastMonth
} from '@/utils/formValidate'
import {
  getDataOverView, //数据概览
  getTurnoverStatistics,
  getUserStatistics,
  getOrderStatistics,
  getTop
} from '@/api/index'
// 组件
// 标题
import TitleIndex from './components/titleIndex.vue'
// 数据概览
import Overview from './components/overview.vue'
// 营业额统计
import TurnoverStatistics from './components/turnoverStatistics.vue'
// 用户统计
import UserStatistics from './components/userStatistics.vue'
// 订单统计
import OrderStatistics from './components/orderStatistics.vue'
// 排名
import Top from './components/top10.vue'
@Component({
  name: 'Dashboard',
  components: {
    TitleIndex,
    Overview,
    TurnoverStatistics,
    UserStatistics,
    OrderStatistics,
    Top
  }
})
export default class extends Vue {
  private overviewData = {} as any
  private flag = 2
  private tateData = []
  private turnoverData = {} as any
  private userData = {}
  private orderData = {
    data: {}
  } as any
  private top10Data = {}
  created() {
    this.init(this.flag)
  }
  // 获取基本数据
  init(flay: any) {
    this.$nextTick(() => {
      this.getOverViewData(flay)
      this.getTurnoverStatisticsData(flay)
      this.getUserStatisticsData(flay)
      this.getOrderStatisticsData(flay)
      this.getTopData(flay)
    })
  }
  // 获取数据概览
  async getOverViewData(flay) {
    const data = await getDataOverView({ flag: flay })
    this.overviewData = data.data.data
  }
  // 获取营业额统计数据
  async getTurnoverStatisticsData(flay: any) {
    const data = await getTurnoverStatistics({ flag: flay })
    const turnoverData = data.data.data
    this.turnoverData = {
      date: turnoverData.date.split(','),
      num: turnoverData.num.split(',')
    }
    this.tateData = this.turnoverData.date
    const arr = []
    this.tateData.forEach(val => {
      let date = new Date()
      let year = date.getFullYear()
      arr.push(year + '-' + val)
    })
    this.tateData = arr
  }
  // 获取用户统计数据
  async getUserStatisticsData(flay: any) {
    const data = await getUserStatistics({ flag: flay })
    const userData = data.data.data
    this.userData = {
      date: userData.date.split(','),
      amount: userData.amount.split(','),
      newNum: userData.newNum.split(',')
    }
  }
  // 获取订单统计数据
  async getOrderStatisticsData(flay: any) {
    const data = await getOrderStatistics({ flag: flay })
    const orderData = data.data.data
    this.orderData = {
      data: {
        date: orderData.date.split(','),
        amount: orderData.amount.split(','),
        validNum: orderData.validNum.split(','),
        accomplishNum: orderData.accomplishNum.split(',')
      },

      totalOrders: orderData.totalOrders
    }
  }
  // 获取排行数据
  async getTopData(flay: any) {
    const data = await getTop({ flag: flay })
    const top10Data = data.data.data
    //接口返回的数据有问题
    this.top10Data = {
      name: top10Data == null ? [] : top10Data.name.split(',').reverse(),
      amount: top10Data == null ? [] : top10Data.amount.split(',').reverse()
    }
  }
  // 获取当前选中的tab时间
  getTitleNum(data) {
    this.init(data)
    switch (data) {
      case 1:
        this.tateData = get1stAndToday()
        break
      case 2:
        this.tateData = past7Day()
        break
      case 3:
        this.tateData = past30Day()
        break
      case 4:
        this.tateData = pastWeek()
        break
      case 5:
        this.tateData = pastMonth()
        break
    }
  }
}
